'use client';

import { productDetailPayloadToBaseCarData } from '@/data/ProductApi/ProductDetailPayloadToBaseCarData';
import type { Carousel } from '@/general/components/Carousel/Carousel';
import { ProductCard } from '@/general/components/ProductCard/ProductCard';
import { ProductCardLoading } from '@/general/components/ProductCard/ProductCardLoading';
import { PlpMarketingTile } from '@/plp/components/PlpMarketingTile/PlpMarketingTile';
import { ProductListDataPayload, ProductListDataRow } from '@/types/CataloguePage.types';
import { pushToDataLayerProductCard } from '@/utils/pushToDataLayerProductCard';
import { ComponentProps } from 'react';

export const generateTiles = (
  isLoading: boolean,
  results?: ProductListDataPayload['results'],
  marketingItems?: ComponentProps<typeof PlpMarketingTile>[],
  onCardClick?: (product: ProductListDataRow, index: number) => void,
): ComponentProps<typeof Carousel>['tiles'] => {
  if (isLoading || !results) {
    return [...Array(4).keys()].map((item) => ({
      id: `${item}`,
      tile: <ProductCardLoading key={`loading-${item}`} />,
    }));
  }

  const tiles = results.map((product, index) => ({
    id: product.sku,
    tile: (
      <ProductCard
        carData={productDetailPayloadToBaseCarData(product)}
        weeklyRepayment={product.weeklyRepayment}
        defaultRate={product.defaultRate}
        variant="default"
        onCardClick={() => {
          pushToDataLayerProductCard(product, index, {
            event: 'carousel_tile_click',
            name: 'recommendedCar',
            value: 'recommendedCar',
          });
          onCardClick?.(product, index);
        }}
      />
    ),
  }));

  if (marketingItems) {
    const marketingTiles = marketingItems.map((tile) => ({
      id: tile.title ?? '',
      tile: <PlpMarketingTile {...tile} variant="carousel" />,
    }));
    tiles.push(...marketingTiles);
  }

  return tiles;
};
